// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chart-draw-io"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M15 17H21V21H15V17Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M15 10H21V14H15V10Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M6 9V19H15M6 9C7.65685 9 9 7.65685 9 6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9ZM6 12H15M15 17H21V21H15V17ZM15 10H21V14H15V10Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChartDrawIoIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chart-draw-io',
    ref,
    icon: element,
  },
));

ChartDrawIoIcon.displayName = 'ChartDrawIoIcon';

export default ChartDrawIoIcon;
